import { render, staticRenderFns } from "./FileContainer.vue?vue&type=template&id=3e89de59&scoped=true"
import script from "./FileContainer.vue?vue&type=script&lang=js"
export * from "./FileContainer.vue?vue&type=script&lang=js"
import style0 from "./FileContainer.vue?vue&type=style&index=0&id=3e89de59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89de59",
  null
  
)

export default component.exports